export default "__VITE_ASSET__C1mM$xt8__"